import { render, staticRenderFns } from "./excursion-coast-form.vue?vue&type=template&id=be881994&"
import script from "./excursion-coast-form.vue?vue&type=script&lang=ts&"
export * from "./excursion-coast-form.vue?vue&type=script&lang=ts&"
import style0 from "./excursion-coast-form.vue?vue&type=style&index=0&id=be881994&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports